if (!customElements.get('calc-shipping-rate-block')) {
	function calculateShipping(button, container, zipCode, country, province) {
		const Notification = window.FoxTheme.Notification
        const TotalShippingContainer = document.querySelector('.totals .f-cart-drawer__shipping-message');
        const GrandTotalContainer = document.querySelector('.f-cart-drawer__grand-total');
		container.innerHTML = ''
		fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`)
			.then(res => res.json())
			.then(res => {
				if (res && res.shipping_rates) {
					const { shipping_rates } = res
					const { shippingRatesResult, noShippingRate } = window.FoxThemeStrings
					if (shipping_rates.length > 0) {
						const html = `${shippingRatesResult.replace('{{count}}', shipping_rates.length)}:`
						const text = generateDomFromString(html, 'p')
						text.classList.add('font-bold')
						// container.appendChild(text)
						if (TotalShippingContainer) TotalShippingContainer.innerHTML = '';
                        if (GrandTotalContainer) GrandTotalContainer.innerHTML = '';
                        
                        const SubtotalPrice = parseFloat(document.querySelector('.totals__subtotal-value')?.getAttribute('data-subtotal')) || 0;
                        
                        shipping_rates.forEach((rate, index) => {
                        if(index === 0){
                          let shippingMatch = "";
                          let taxesMatch = "";
                          let dutiesMatch = "";
                          if(rate.description){
                            shippingMatch = rate.description.match(/([\d.,]+)\s*[^\d]*Shipping/i);
                            taxesMatch = rate.description.match(/([\d.,]+)\s*[^\d]*taxes/i);
                            dutiesMatch = rate.description.match(/([\d.,]+)\s*[^\d]*duties/i); 
                          }
                          
                          
                          const shipping = shippingMatch ? shippingMatch[1] : '';
                          const taxes = taxesMatch ? taxesMatch[1] : '';
                          const duties = dutiesMatch ? dutiesMatch[1] : '';
                          
                          console.log('shipping', shipping);
                          console.log('taxes', taxes);
                          console.log('duties', duties);

                            
                            // Generate HTML content
                          
                            const taxesHtml = `Taxes: <strong>${currency_symbol + taxes}</strong>`;
                            const dutiesHtml = `Duties: <strong>${currency_symbol + duties}</strong>`;
                            
                            // Convert to <p> elements
                            const taxesMessage = generateDomFromString(taxesHtml, 'p');
                            const dutiesMessage = generateDomFromString(dutiesHtml, 'p');

                          
                          var cleanedName = rate.name.replace('Duties & Taxes Included', '').trim();
                          let Shippinghtml = '';
                          
                          if (shipping) {
                            Shippinghtml = `${cleanedName}: <strong>${currency_symbol + shipping}</strong>`;
                          } else {
                            Shippinghtml = `${cleanedName}: <strong>${formatMoney(rate.price, window.FoxThemeSettings.money_format)}</strong>`;
                          }
                          const message = generateDomFromString(Shippinghtml, 'p');
                          // Extract values based on the keywords "taxes" and "duties"

                         


                          

                             // Use global match for all numbers before keywords
                       
                            if (TotalShippingContainer) {
                              TotalShippingContainer.appendChild(message);
                              if(taxes){
                                TotalShippingContainer.appendChild(taxesMessage);
                              }
                              if(duties){
                                TotalShippingContainer.appendChild(dutiesMessage);
                              }
                              
                              var Shipping = formatMoney(rate.price, window.FoxThemeSettings.money_format);
                              if (!Shipping) {
                                Shipping = '';
                              }
                              
                              var ShippingMethod = rate.name;
                              if (!ShippingMethod) {
                                ShippingMethod = '';
                              }

                              var MainTaxes = "";
                              if(taxes != ''){
                                MainTaxes = currency_symbol + (parseFloat(taxes) + parseFloat(duties)).toFixed(2);
                              }

                              var TaxDescription = '';
                              if(rate.description){
                                 TaxDescription = rate.description.split('Shipping,')[1].trim()
                              }
                              
                              
                              // Make sure this function is defined properly BEFORE this call:
                              updateCartAttribute(Shipping, ShippingMethod, MainTaxes, TaxDescription);
                            }
                          }

                        
                          if (index === 0 && GrandTotalContainer && SubtotalPrice) {
                            const grandTotal = (SubtotalPrice + parseFloat(rate.price)).toFixed(2);
                            const grandTotalHtml = `Grand Total: <strong>${currency_symbol + grandTotal}</strong>`;
                            const grandTotalMessage = generateDomFromString(grandTotalHtml, 'p');
                            GrandTotalContainer.appendChild(grandTotalMessage);
                          }
                        
                          if (container) {
                            // container.appendChild(message.cloneNode(true)); // only deep clone once
                          }
                        });
					} else {
                        if(TotalShippingContainer){
                          TotalShippingContainer.innerHTML = `<p>${noShippingRate}</p>`
                        }
                         var Shipping = '';
                         var ShippingMethod = '';
                            
                        // Make sure this function is defined properly BEFORE this call:
                        updateCartAttribute(Shipping, ShippingMethod);
                              
						// container.innerHTML = `<p>${noShippingRate}</p>`
					}
                    // document.querySelector('.tax-note').style.display="none";
				} else {
                    // document.querySelector('.tax-note').style.display="block";

                     var Shipping = '';
                     var ShippingMethod = '';
                        
                    // Make sure this function is defined properly BEFORE this call:
                    updateCartAttribute(Shipping, ShippingMethod);
                    if (TotalShippingContainer) TotalShippingContainer.innerHTML = '';
                    if (GrandTotalContainer) GrandTotalContainer.innerHTML = '';
					Object.entries(res).map(error => {
						Notification.show({
							target: container,
							method: 'appendChild',
							type: 'warning',
							message: error[1][0],
							last: 3000
						})
					})
				}
			})
			.catch(console.error)
			.finally(() => button.classList.remove('btn--loading'))
	}

	customElements.define('calc-shipping-rate-block', class FooterCalcShippingRates extends HTMLElement {
		constructor() {
			super()
			this.selectors = {
				button: '.btn-calc',
				zipCode: '[name="address[zip]"]',
				province: '[name="address[province]"]',
				country: '[name="address[country]"]',
				shippingRates: '.f-cart-drawer__shipping-message',
				countries: 'template'
			}
			this.initAddress = false
			this.domNodes = queryDomNodes(this.selectors, this)
			this.collapsibleTab = this.querySelector('collapsible-tab')

			this.domNodes.button.addEventListener('click', this.fetchRates.bind(this))
			if (this.collapsibleTab) {
				setTimeout(() => {
					this.collapsibleTab.on('tabOpened', this.setupCountries.bind(this))
				}, 1000)
			}
			this.querySelector('.btn-cancel').addEventListener('click', this.handleClose.bind(this))
		}

		fetchRates(e) {
			e.preventDefault()
			this.domNodes.button.classList.add('btn--loading')
			const {zipCode, country, province} = this.domNodes
			calculateShipping(this.domNodes.button, this.domNodes.shippingRates, zipCode.value.trim(), country.value, province.value)
		}

		setupCountries() {
            
			if (this.initAddress) return false;
			this.domNodes.country.innerHTML = this.domNodes.countries.innerHTML
			if (Shopify && Shopify.CountryProvinceSelector) {
				// eslint-disable-next-line no-new
				new Shopify.CountryProvinceSelector(
					"AddressCountry",
					"AddressProvince",
					{
						hideElement: "AddressProvinceContainer",
					}
				);
				this.initAddress = true
			}
		}

		handleClose(e) {
			e.preventDefault()
			if (this.collapsibleTab) this.collapsibleTab.close()
		}
	})
}



document.addEventListener('DOMContentLoaded', () => {
 if(iscustomer){
    if (window.customerAddress?.zip || window.customerAddress?.province) {
    const calcBlock = document.querySelector('calc-shipping-rate-block');
    if (!calcBlock) return;

    calcBlock.setupCountries?.();

    calcBlock.domNodes.zipCode.value = window.customerAddress.zip;
    calcBlock.domNodes.province.value = window.customerAddress.province;
    calcBlock.domNodes.country.value = window.customerAddress.country;

    document.querySelector('#AddressProvinceContainer')?.style.setProperty('display', 'block');

    const button = calcBlock.domNodes.button;
    const container = calcBlock.domNodes.shippingRates;

    calculateShipping(button, container, window.customerAddress.zip, window.customerAddress.country, window.customerAddress.province);

  }
 }
});





function updateCartAttribute(shippingValue, shippingMethod, MainTaxes, TaxDescription) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        'shipping': shippingValue,
        'shipping method': shippingMethod,
        'Tax': MainTaxes,
        'Tax_description': TaxDescription
      }
    })
  })
  .then(response => {
    if (!response.ok) throw new Error('Failed to update cart');
    return response.json();
  })
  .then(() => {
    // Success
  })
  .catch(error => {
    console.error('Error:', error);
  });
}


